import React from "react";
import "./Concept.css";
import { Flex, Header, SafeArea } from "../../components/layout";
import { Image, Text } from "../../components/ui";

import Fire from "../../assets/images/fire.png";
import Water from "../../assets/images/water.png";
import Wind from "../../assets/images/wind.png";
import Plant from "../../assets/images/plant.png";
import { Link } from "react-router-dom";

function Concept() {
  return (
    <SafeArea className="Concept">
      <Flex type="col" gap={50}>
        <Header title="Le Concept">
          Au sein de l’Ecrin Sauvage, lieu d'échanges et de partage, situé au
          cœur de la nature, nous vous offrons l’opportunité d’aller{" "}
          <span>à la rencontre de vous-même</span> dans un cadre{" "}
          <span>inspirant et sécurisant</span> au travers de pratiques porteuses
          de sens et d’ateliers d’éveil ressourçants animés par des
          professionnels.
        </Header>
        <Flex type="center" gap={50} className="ctn-images" wrap>
          <Link to="/elements/feu">
            <Flex type="col-center" gap={15}>
              <Image src={Fire} alt="" />
              <Text>Feu</Text>
            </Flex>
          </Link>
          <Link to="/elements/eau">
            <Flex type="col-center" gap={15}>
              <Image src={Water} alt="" />
              <Text>Eau</Text>
            </Flex>
          </Link>
          <Link to="/elements/air">
            <Flex type="col-center" gap={15}>
              <Image src={Wind} alt="" />
              <Text>Air</Text>
            </Flex>
          </Link>
          <Link to="/elements/terre">
            <Flex type="col-center" gap={15}>
              <Image src={Plant} alt="" />
              <Text>Terre</Text>
            </Flex>
          </Link>
        </Flex>
      </Flex>
    </SafeArea>
  );
}

export default Concept;
